// Indian Festivals for 2026 - Madhya Pradesh focused
// All dates verified from official sources
// Dates are in YYYY-MM-DD format

const indianFestivals2026 = [
  // January
  {
    date: '2026-01-14',
    name: 'Makar Sankranti',
    wish: 'Happy Makar Sankranti! May the sun bring warmth and prosperity into your life!',
    animation: 'kites',
    colors: ['#FF6B35', '#F7C59F', '#2EC4B6', '#E71D36', '#011627'],
    emoji: '🪁',
    regionalNames: ['Pongal', 'Lohri', 'Uttarayan']
  },
  {
    date: '2026-01-23',
    name: 'Vasant Panchami',
    wish: 'Happy Vasant Panchami! May Goddess Saraswati bless you with knowledge and wisdom!',
    animation: 'flowers',
    colors: ['#FFD700', '#FFF8DC', '#FFFFE0'],
    emoji: '🌸'
  },
  {
    date: '2026-01-26',
    name: 'Republic Day',
    wish: 'Happy Republic Day! Jai Hind! Saluting the spirit of our great nation!',
    animation: 'tricolor',
    colors: ['#FF9933', '#FFFFFF', '#138808'],
    emoji: '🇮🇳'
  },

  // February
  {
    date: '2026-02-15',
    name: 'Maha Shivratri',
    wish: 'Happy Maha Shivratri! May Lord Shiva bless you with peace and prosperity!',
    animation: 'diyas',
    colors: ['#4B0082', '#8B4513', '#FFD700'],
    emoji: '🙏'
  },

  // March
  {
    date: '2026-03-03',
    name: 'Holika Dahan',
    wish: 'Happy Holika Dahan! May the sacred fire burn away all negativity!',
    animation: 'fire',
    colors: ['#FF4500', '#FFD700', '#FF6347'],
    emoji: '🔥'
  },
  {
    date: '2026-03-04',
    name: 'Holi',
    wish: 'Happy Holi! May your life be filled with vibrant colors of joy and happiness!',
    animation: 'colors',
    colors: ['#FF1493', '#00FF00', '#FFFF00', '#FF4500', '#9400D3', '#00BFFF'],
    emoji: '🎨'
  },
  {
    date: '2026-03-19',
    name: 'Gudi Padwa / Ugadi',
    wish: 'Happy Gudi Padwa! May the new year bring you prosperity and happiness!',
    animation: 'flowers',
    colors: ['#FFD700', '#FF6347', '#32CD32'],
    emoji: '🌺'
  },
  {
    date: '2026-03-21',
    name: 'Eid ul-Fitr',
    wish: 'Eid Mubarak! May this blessed day bring you joy, peace, and prosperity!',
    animation: 'crescentMoon',
    colors: ['#008000', '#FFD700', '#FFFFFF'],
    emoji: '🌙'
  },
  {
    date: '2026-03-26',
    name: 'Ram Navami',
    wish: 'Happy Ram Navami! May Lord Rama bless you with peace and prosperity!',
    animation: 'diyas',
    colors: ['#FF9933', '#FFD700', '#FFA500'],
    emoji: '🙏'
  },
  {
    date: '2026-03-30',
    name: 'Mahavir Jayanti',
    wish: 'Happy Mahavir Jayanti! May the teachings of Lord Mahavir guide you to peace!',
    animation: 'lotus',
    colors: ['#FFFFFF', '#FFD700', '#FFA500'],
    emoji: '☸️'
  },

  // April
  {
    date: '2026-04-03',
    name: 'Good Friday',
    wish: 'Blessed Good Friday! May this day bring you peace and reflection.',
    animation: 'candles',
    colors: ['#800020', '#FFFFFF', '#8B4513'],
    emoji: '✝️'
  },
  {
    date: '2026-04-14',
    name: 'Ambedkar Jayanti',
    wish: 'Remembering Dr. B.R. Ambedkar on his birth anniversary. Jai Bhim!',
    animation: 'tricolor',
    colors: ['#0000FF', '#FFFFFF', '#FFD700'],
    emoji: '📘'
  },
  {
    date: '2026-04-14',
    name: 'Baisakhi',
    wish: 'Happy Baisakhi! May the harvest season bring you abundance and joy!',
    animation: 'wheat',
    colors: ['#FFD700', '#228B22', '#FF8C00'],
    emoji: '🌾'
  },

  // May
  {
    date: '2026-05-01',
    name: 'Buddha Purnima',
    wish: 'Happy Buddha Purnima! May the wisdom of Buddha enlighten your path!',
    animation: 'lotus',
    colors: ['#FFFFFF', '#FFD700', '#87CEEB'],
    emoji: '☸️'
  },
  {
    date: '2026-05-27',
    name: 'Eid ul-Adha',
    wish: 'Eid ul-Adha Mubarak! May this day bring blessings and happiness to you and your family!',
    animation: 'crescentMoon',
    colors: ['#008000', '#FFD700', '#FFFFFF'],
    emoji: '🕌'
  },

  // June
  {
    date: '2026-06-26',
    name: 'Muharram',
    wish: 'May this Muharram bring peace and blessings to you and your family.',
    animation: 'crescentMoon',
    colors: ['#000000', '#008000', '#FFFFFF'],
    emoji: '🕌'
  },

  // August
  {
    date: '2026-08-15',
    name: 'Independence Day',
    wish: 'Happy Independence Day! Jai Hind! Let us celebrate the spirit of freedom!',
    animation: 'tricolor',
    colors: ['#FF9933', '#FFFFFF', '#138808'],
    emoji: '🇮🇳'
  },
  {
    date: '2026-08-28',
    name: 'Raksha Bandhan',
    wish: 'Happy Raksha Bandhan! Celebrating the beautiful bond of brothers and sisters!',
    animation: 'rakhi',
    colors: ['#FF1493', '#FFD700', '#FF69B4', '#9370DB'],
    emoji: '🎀'
  },

  // September
  {
    date: '2026-09-04',
    name: 'Janmashtami',
    wish: 'Happy Janmashtami! May Lord Krishna fill your life with love and happiness!',
    animation: 'peacockFeather',
    colors: ['#000080', '#FFD700', '#4169E1'],
    emoji: '🪈'
  },
  {
    date: '2026-09-14',
    name: 'Ganesh Chaturthi',
    wish: 'Ganpati Bappa Morya! May Lord Ganesha remove all obstacles from your life!',
    animation: 'modak',
    colors: ['#FF9933', '#FFD700', '#FF4500'],
    emoji: '🐘'
  },

  // October
  {
    date: '2026-10-02',
    name: 'Gandhi Jayanti',
    wish: 'Remembering the Father of our Nation on Gandhi Jayanti. Be the change you wish to see!',
    animation: 'charkha',
    colors: ['#FFFFFF', '#808080', '#000000'],
    emoji: '☮️'
  },
  {
    date: '2026-10-11',
    name: 'Navratri Begins',
    wish: 'Shubh Navratri! May the nine nights of worship bring divine blessings!',
    animation: 'diyas',
    colors: ['#FF0000', '#FFD700', '#FF4500'],
    emoji: '🔱'
  },
  {
    date: '2026-10-17',
    name: 'Durga Ashtami',
    wish: 'Subho Maha Ashtami! May the divine blessings of Maa Durga be with you!',
    animation: 'dhunuchi',
    colors: ['#FF0000', '#FFD700', '#FF4500'],
    emoji: '🔱'
  },
  {
    date: '2026-10-18',
    name: 'Maha Navami',
    wish: 'Subho Maha Navami! May Maa Durga bestow her blessings upon you!',
    animation: 'dhunuchi',
    colors: ['#FF0000', '#FFD700', '#FFFFFF'],
    emoji: '🔱'
  },
  {
    date: '2026-10-20',
    name: 'Dussehra',
    wish: 'Happy Dussehra! May good always triumph over evil! Shubh Vijayadashami!',
    animation: 'fireworks',
    colors: ['#FFD700', '#FF4500', '#FF0000'],
    emoji: '🏹'
  },
  {
    date: '2026-10-29',
    name: 'Karwa Chauth',
    wish: 'Happy Karwa Chauth! May your love shine as bright as the moon!',
    animation: 'moon',
    colors: ['#FF1493', '#FFD700', '#FF69B4'],
    emoji: '🌕'
  },

  // November
  {
    date: '2026-11-01',
    name: 'MP Foundation Day',
    wish: 'Happy Madhya Pradesh Foundation Day! Celebrating the heart of India!',
    animation: 'tricolor',
    colors: ['#FF9933', '#FFFFFF', '#138808'],
    emoji: '🎉'
  },
  {
    date: '2026-11-06',
    name: 'Dhanteras',
    wish: 'Happy Dhanteras! May Goddess Lakshmi bless you with wealth and prosperity!',
    animation: 'coins',
    colors: ['#FFD700', '#FFA500', '#DAA520'],
    emoji: '💰'
  },
  {
    date: '2026-11-07',
    name: 'Choti Diwali',
    wish: 'Happy Choti Diwali! Let the festival of lights begin!',
    animation: 'diyas',
    colors: ['#FFD700', '#FF4500', '#FF6347'],
    emoji: '🪔'
  },
  {
    date: '2026-11-08',
    name: 'Diwali',
    wish: 'Happy Diwali! May this festival of lights bring joy, prosperity, and happiness to your life!',
    animation: 'fireworks',
    colors: ['#FFD700', '#FF4500', '#FF1493', '#00FF00', '#9400D3'],
    emoji: '🪔'
  },
  {
    date: '2026-11-09',
    name: 'Govardhan Puja',
    wish: 'Happy Govardhan Puja! May Lord Krishna shower his blessings upon you!',
    animation: 'diyas',
    colors: ['#FFD700', '#4169E1', '#228B22'],
    emoji: '⛰️'
  },
  {
    date: '2026-11-10',
    name: 'Bhai Dooj',
    wish: 'Happy Bhai Dooj! Celebrating the precious bond between siblings!',
    animation: 'tilak',
    colors: ['#FF1493', '#FFD700', '#FF6347'],
    emoji: '👫'
  },
  {
    date: '2026-11-14',
    name: "Children's Day",
    wish: "Happy Children's Day! Celebrating the joy and innocence of childhood!",
    animation: 'balloons',
    colors: ['#FF69B4', '#00BFFF', '#FFD700', '#32CD32', '#FF6347'],
    emoji: '🎈'
  },
  {
    date: '2026-11-15',
    name: 'Chhath Puja',
    wish: 'Happy Chhath Puja! May the Sun God bless you with health and prosperity!',
    animation: 'sunrise',
    colors: ['#FF4500', '#FFD700', '#FF6347'],
    emoji: '🌅'
  },
  {
    date: '2026-11-24',
    name: 'Guru Nanak Jayanti',
    wish: 'Happy Guru Nanak Jayanti! May the teachings of Guru Nanak Dev Ji inspire you!',
    animation: 'candles',
    colors: ['#FF9933', '#FFFFFF', '#000080'],
    emoji: '🙏'
  },

  // December
  {
    date: '2026-12-25',
    name: 'Christmas',
    wish: 'Merry Christmas! May this festive season bring you joy and happiness!',
    animation: 'snowflakes',
    colors: ['#FF0000', '#228B22', '#FFFFFF', '#FFD700'],
    emoji: '🎄'
  },
  {
    date: '2026-12-31',
    name: "New Year's Eve",
    wish: 'Happy New Year! Wishing you a year filled with success and happiness!',
    animation: 'fireworks',
    colors: ['#FFD700', '#C0C0C0', '#9400D3', '#00FF00'],
    emoji: '🎆'
  }
];

// Helper function to get today's festival
export const getTodaysFestival = () => {
  const today = new Date();
  const todayString = today.toISOString().split('T')[0];
  return indianFestivals2026.find(festival => festival.date === todayString);
};

// Helper function to get upcoming festivals (next 7 days)
export const getUpcomingFestivals = (days = 7) => {
  const today = new Date();
  const futureDate = new Date(today);
  futureDate.setDate(today.getDate() + days);

  const todayString = today.toISOString().split('T')[0];
  const futureDateString = futureDate.toISOString().split('T')[0];

  return indianFestivals2026.filter(festival =>
    festival.date > todayString && festival.date <= futureDateString
  );
};

// Helper function to get next festival
export const getNextFestival = () => {
  const today = new Date();
  const todayString = today.toISOString().split('T')[0];
  return indianFestivals2026.find(festival => festival.date >= todayString);
};

// Helper function to calculate days until festival
export const getDaysUntilFestival = (festivalDate) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const festival = new Date(festivalDate);
  const diffTime = festival - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export default indianFestivals2026;
